import styled, { StyledComponentProps } from 'styled-components';

interface ContainerProps extends StyledComponentProps<'section', any, {}, never> {
  hasSingleChild?: boolean;
}

export const Container = styled.section<ContainerProps>`
  display: flex;
  justify-content: ${({ hasSingleChild }) => (hasSingleChild ? 'flex-start' : 'space-evenly')};
  flex-wrap: wrap;

`;

export const Star = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 38px;
  font-size: 11px;
  font-weight: bold;
  flex-shrink: 0;
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url('/corporate/images/star-filter.svg');
  color: ${({ theme }) => theme.starsFilter.color};
  margin-top: 8px;

  &.active {
    background-image: url('/corporate/images/star-filter-active.svg');
    color: ${({ theme }) => theme.starsFilter.active};
  }
`;
